import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Provider } from "risa-data-model";
import { AuthStatusOptionModel } from "../../../data-model/authStatusOptions";
import { BOOptionModel } from "../../../data-model/boOptionModel";
import { fetchMultiFacetsCountFromAlgolia } from "../../../redux/slice/medicalPa/algoliaMultiFacetsCountSlice";
import { AppDispatch } from "../../../redux/store/store";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";

interface UseAlgoliaMultiFacetsDataProps {
  authStatusOptions: AuthStatusOptionModel[];
  boOptions: BOOptionModel[];
  providerDetails: Provider | null;
}

/**
 * Custom hook to manage Algolia multi-facets count data fetching
 * Handles the dispatch logic and dependency management for Algolia data
 */
export const useAlgoliaMultiFacetsData = ({
  authStatusOptions,
  boOptions,
  providerDetails,
}: UseAlgoliaMultiFacetsDataProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const orgId = useMemo(() => getOrgIdForFetchExternalWorklist(), []);

  useEffect(() => {
    dispatch(
      fetchMultiFacetsCountFromAlgolia({
        org_id: orgId,
      }),
    );
  }, [dispatch, orgId, authStatusOptions, boOptions, providerDetails]);
};
